export default __webpack_public_path__ + "static/media/emo.71a179dc.svg";